import {getDay} from "@/utils/hebrewDateFormat";

const days = [
    {id: "0", display: "ראשון", value: 0},
    {id: "1", display: "שני", value: 1},
    {id: "2", display: "שלישי", value: 2},
    {id: "3", display: "רביעי", value: 3},
    {id: "4", display: "חמישי", value: 4},
    {id: "5", display: "שישי", value: 5},
]

import axios from "axios";
import {getGradeFullName, getTeacher, getTeacherShortName, getGrade, getLessonFullName} from "@/utils/parseObj";

export async function getGradeScheduleByDayAndLesson(day, lesson) {
    const {data} = await axios.get(`/schedule/allByLessonAndDay/${day}/${lesson}`);

    const teachers = []
    if (data){
        data.forEach((schedule) => {
            if (schedule.teacher !== null){
                const teacherObj = getTeacher(schedule.teacher)
                teacherObj.disabled = true
                teacherObj.error =`בכיתה: ${getGradeFullName(schedule._id.grade)}`
                teachers.push(teacherObj)
            }

        })
    }

    return teachers
}


export async function getTeacherScheduleByDayAndLesson(day, lesson) {
    const {data} = await axios.get(`/schedule/allByLessonAndDay/${day}/${lesson}`);

    const grades = []
    if (data){
        data.forEach((schedule) => {
            if (schedule?._id?.grade !== null){
                const gradeObj = getGrade(schedule._id.grade)
                gradeObj.disabled = true
                gradeObj.error =`${getTeacherShortName(schedule.teacher)}: ${getLessonFullName(schedule.subject)}`
                grades.push(gradeObj)
            }

        })
    }
    return grades
}

export async function getScheduleByGrade(grade) {
    const {data} = await axios.get(`/schedule/allByGrade/${grade}`);
    const lessonGroup = {}

    data.forEach((schedule) => {
        if (lessonGroup[schedule._id.lesson] === undefined) lessonGroup[schedule._id.lesson] = {}
        lessonGroup[schedule._id.lesson][schedule._id.day] = {
            subject: schedule.subject,
            teacher: schedule.teacher,
            lesson: schedule._id.lesson,
            day: schedule._id.day,
        }
    })
    return lessonGroup
}

export async function deleteSchedule(scheduleId) {
    const {data} = await axios.delete(`/schedule/delete-many`,{
        data: [scheduleId]
    });

    return data
}

export async function getScheduleByTeacher(allByTeacher) {
    const {data} = await axios.get(`/schedule/allByTeacher/${allByTeacher}`);
    const lessonGroup = {}

    data.forEach((schedule) => {
        if (lessonGroup[schedule._id.lesson] === undefined) lessonGroup[schedule._id.lesson] = {}
        lessonGroup[schedule._id.lesson][schedule._id.day] = {
            subject: schedule.subject,
            teacher: schedule.teacher,
            lesson: schedule._id.lesson,
            day: schedule._id.day,
            grade: schedule._id.grade,
            schedule
        }
    })
    return {lessonGroup, lessonLength: data.length}
}

export async function getWeekStudyByTeacher(teacher, weekRange) {
   const first = new Date(weekRange.firstDay)
   const lastDay = new Date(weekRange.lastDay)
    try {
        first.setDate(first.getDate() - 1);
        first.setHours(23)
        first.setMinutes(59)
        first.setSeconds(59)


        const {data} = await axios.get(`/study/teacher/${teacher}/${first.getTime()}/${lastDay.getTime()}`);
        const studyGroup = {}
        //
        data.forEach((study) => {
            if (studyGroup[study.time] === undefined) studyGroup[study.time] = {}
            const day = getDay(study.date)
            studyGroup[study.time][day] = {
                subject: study.subject,
                content: study.content,
                study
                //         lesson: schedule._id.lesson,
                //         day: schedule._id.day,
                //         grade: schedule._id.grade,
            }
        })

        return {studyGroup, studyLength : data.length || 0}
    }catch (e) {
        console.log("eEEe", e)
    }

}

export {days}

